import { Card, CardContent, Container, Typography } from '@mui/material'
import { useLocation, type Location } from 'react-router-dom'

export const Login = () => {
  const location = useLocation()

  const fromPage = (location.state as { from?: Location })?.from?.pathname || '/'
  return (
    <Container maxWidth="lg">
      <Card>
        <CardContent>
          <Typography variant="h2" align="center">
            Страница авторизации
          </Typography>
          <p>{fromPage}</p>
        </CardContent>
      </Card>
    </Container>
  )
}
